import { usersOrganisationsRolesQueryOptions } from "@/features/auth/api/selectUsersOrganisationsRoles";
import { getOnboardedAppHome } from "@/features/auth/utils/getAuthenticatedPublicLanding";
import { validationByIdQueryOptions } from "@/features/validations/api/selectValidationById";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/validate/$validationId")({
    component: () => <Outlet />,
    beforeLoad: async ({ context }) => {
        const userId = context?.auth?.id;
        if (!userId || !context?.queryClient) {
            throw redirect({ to: "/login" });
        }

        const roles = await context.queryClient.ensureQueryData(usersOrganisationsRolesQueryOptions(userId));
        context.auth.roles.setRoles(roles ?? []);

        if (!context.auth.roles.isValidator && !context.auth.roles.isAdmin) {
            throw redirect({ to: getOnboardedAppHome(context.auth.roles) });
        }

        return context;
    },
    loader: async ({ context, params }) => {
        await context?.queryClient.ensureQueryData(validationByIdQueryOptions(params.validationId));
    },
});
